import { getPasswordPolicyResult, PasswordIdentityContext } from '../utils/passwordPolicy';

interface PasswordStrengthMeterProps {
  password?: string;
  context?: PasswordIdentityContext;
}

export default function PasswordStrengthMeter({
  password = '',
  context,
}: PasswordStrengthMeterProps) {
  const result = getPasswordPolicyResult(password, context);

  return (
    <div className="space-y-1.5">
      <div className="flex items-center justify-between text-[11px] text-gray-500">
        <span>Password strength</span>
        <span className="font-medium text-gray-700">{result.label}</span>
      </div>
      <div className="h-1.5 overflow-hidden rounded-full bg-gray-200">
        <div
          className={`h-full rounded-full transition-all ${result.colorClassName}`}
          style={{ width: `${result.percent}%` }}
        />
      </div>
    </div>
  );
}
